exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#fbplus-wrap {\n  box-sizing: content-box !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/modules/fancybox-plus/fancybox-plus.scss
// module id = 740
// module chunks = 3